"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _messages = _interopRequireDefault(require("../../lib/messages"));
function _default(intl) {
  return {
    addOns: {
      'consent-add-on': [{
        sentence: intl.formatMessage(_messages.default.confirmText)
      }, {
        hasModal: true,
        modalContent: {
          body: intl.formatMessage(_messages.default.confirmModalContent),
          title: intl.formatMessage(_messages.default.confirmModalTitle)
        },
        sentence: intl.formatMessage(_messages.default.learnMoreLink)
      }]
    },
    fields: [{
      label: intl.formatMessage(_messages.default.cancelationReasonNotesTitle),
      path: 'apptCancel.notes',
      rows: 5,
      type: 'textarea',
      maxLength: 500,
      displayCharacterCount: true
    }]
  };
}